<template>
    <aside class="sidebar bg-white sidebar--hidden" :class="{'toggled': toggled}">
        <div class="scrollbar-inner">
            <ul class="navigation">
                <li v-for="menuItem in getMenuItems" :class="{'navigation__active': linkSelected(menuItem)}">
                    <router-link :to="menuItem.link">
                        <i :class="['zmdi zmdi-' + menuItem.icon]"></i>
                        <span>{{ menuItem.label }}</span>
                    </router-link>
                </li>
            </ul>
        </div>
    </aside>
</template>

<script>
    export default {
        data() {
            return {
                toggled: true
            }
        },

        props: {
            menuItems: {default: function () { return [] }},
            name: {default: 'menuSidebar'}
        },

        computed: {
            getMenuItems(){
                return this.$store.getters.getMenuItems
            },
        },

        methods: {
            linkSelected(menuItem) {
                if(menuItem.name === this.$route.params.module){
                    return true
                }
                else{
                    return false
                }
            },
        },

        beforeMount() {
            if(this.isMobileScreen()){
                this.toggled = false
            }
        },

        mounted() {
            this.$eventBus.$on('toggleSlider', (data) => {
                if(this.name !== data.slider){
                    return
                }

                if(data.status === 'open'){
                    this.toggled = true
                }
                else{
                    this.toggled = false
                }
            })
        }
    }
</script>